import {
  createReport,
  downloadReport,
  excelWorksheetBuilder
} from "@saleor/utils/downloadReport";
import { useJsonToCsv } from "react-json-csv";

function useDownloadReport(
  data,
  fields,
  sheetName,
  filename,
  filetype: "xlsx" | "csv" = "xlsx"
) {
  switch (filetype) {
    case "csv": {
      const { saveAsCsv } = useJsonToCsv();
      saveAsCsv({ data, fields, filename });
      break;
    }
    case "xlsx": {
      createReport().then(workbook => {
        const worksheet = excelWorksheetBuilder(workbook, sheetName);

        worksheet.addHeaders(fields);
        worksheet.addRecords(data);

        downloadReport(workbook, filename);
      });

      break;
    }
    default: {
      return;
    }
  }
}

export default useDownloadReport;
